<div class="landing-nav-container d-flex flex-column">
  <app-landing-score></app-landing-score>
  <app-landing-plan></app-landing-plan>
  <app-landing-nav-item
    *ngFor="let navItem of navigationItems"
    [item]="navItem"
  ></app-landing-nav-item>
</div>
